import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

export default class Message extends React.Component {
	render () {
		const { text, type } = this.props;
		return (
			<span>
				<Glyphicon key={type} glyph={` gg icon-GG-${type}`} />
				{' '}
				<span>{text}</span>
			</span>
		);
	}
}

Message.propTypes = {
	/**
	 * The updates available for the service.
	 */
	text: PropTypes.string.isRequired,
	/**
	 * The icon for the type of message to generate.
	 */
	type: PropTypes.oneOf([
		'info', 'cross-circle'
	])
};

Message.defaultProps = {
	type: 'info'
};
